import React from "react";

export default function CategoryCard({ category, onSelect }) {
    return (
        <button
            type="button"
            onClick={() => onSelect && onSelect(category)}
            className="ll-card ll-card-hover text-left w-full"
            data-testid={`category-card-${category.slug}`}>
            <span className="ll-pill mb-4">{category.name}</span>
            <h3 className="font-serif text-xl font-semibold tracking-tight mb-2">{category.name}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">{category.description}</p>
            <ul className="space-y-1.5 text-sm">
                {(category.prompts || []).slice(0, 3).map((p, i) => (
                    <li key={i} className="flex items-start gap-2">
                        <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-primary inline-block flex-shrink-0" />
                        <span>{p}</span>
                    </li>
                ))}
            </ul>
        </button>
    );
}
